(function() { window.GUID_ead72d47_db0b_42df_8994_a2783fdb390e = { getGuid: function() { return "ead72d47-db0b-42df-8994-a2783fdb390e"; } }; })();
var CompuSport;
(function (CompuSport) {
    class CSRequestAnimationFrame {
        Request(callback) {
            let me = this;
            if (me.inProcess) {
                return;
            }
            me.inProcess = true;
            requestAnimationFrame(function () {
                callback.call(me);
                me.inProcess = false;
            });
        }
    }
    CompuSport.CSRequestAnimationFrame = CSRequestAnimationFrame;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=CSRequestAnimationFrame.js.map
